export interface ISolarCustomerDetailsRequest {
  igsCustomerNumber: string;
}

export class SolarCustomerDetailsRequest
  implements ISolarCustomerDetailsRequest {
  public igsCustomerNumber: string;

  constructor(igsCustomerNumber?: string) {
    this.igsCustomerNumber = igsCustomerNumber;
  }
}
